export default class CopyToClipboard {

    constructor() {

        this.settings = {
            button : $('#copy-to-clipboard')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.button.length) {
            const $temp = $("<input>");
            const $url = $(location).attr('href');

            $('#copy-to-clipboard').click(function () {
                $("body").append($temp);
                $temp.val($url).select();
                document.execCommand("copy");
                $temp.remove();
                $("#copyMessage").text("URL copied!");
            });
        }

    }

};

new CopyToClipboard();